import { css } from '@emotion/react'
import * as Sentry from '@sentry/node'
import Head from 'next/head'
import { Fragment } from 'react'
import { useRouteSelector } from '../components/Hooks/useRoute'
import GenericErrorComponent from '../components/presentation/Error/GenericError'
import NotFoundErrorComponent from '../components/presentation/Error/NotFoundError'
import { InformationCard } from '../components/presentation/InformationCard'
import { getThemeSpacing } from '../components/styles/appTheme'
import { palette } from '../components/styles/colors'
import shape from '../components/styles/shape'
import {
    ErrorReportingEnums,
    SentrySeverity,
} from '../constants/errorReporting'

const sectionStyles = css({
    borderTopLeftRadius: shape.borderRadius,
    borderTopRightRadius: shape.borderRadius,
    background: palette.background,
    paddingTop: getThemeSpacing(4),
    width: '100%',
    '& a': {
        fontWeight: 400,
    },
})
/**
 * https: */
function Error(error) {
    const { statusCode } = error
    const { user } = useRouteSelector('baseQuery')
    Sentry.addBreadcrumb({
        category: ErrorReportingEnums.error_page,
        message: `Error Code`,
        level: SentrySeverity.Error,
    })
    return (
        <Fragment>
            <Head>
                <title>{`${
                    statusCode?.toString() || 'Error'
                } - MyFreeCams App`}</title>
            </Head>
            <section css={sectionStyles} data-testid="ErrorPage__Container">
                <InformationCard
                    title={'Oops!'}
                    description={
                        <Fragment>
                            <span>{statusCode}</span>
                            <h1>{statusCode}</h1>
                            <NotFoundErrorComponent user={user} />
                            <GenericErrorComponent />
                        </Fragment>
                    }
                />
            </section>
        </Fragment>
    )
}

export default Error
